package com.essntl.features.message.domain.model

import com.essntl.uikit.components.chat.contact.ContactUiState
import com.essntl.uikit.components.chat.message.MessageUiState
import kotlinx.datetime.Clock

data class WhapiMessageModel(
    val id: String,
    val fromMe: Boolean,
    val type: Type?,
    val chatId: String,
    val text: String?,
    val timestamp: Int,
    val from: String,
    val fromName: String?,
    val action: WhapiMessageAction?,
    val linkPreviewModel: LinkPreviewModel?,
    val status: Status?,
    val source: String?,
) {
    fun toUiState(
        senderName: String?,
        reactions: List<WhapiMessageModel>,
        contact: ContactUiState,
    ): MessageUiState {
        val reactionsUiState = reactions
            .map { message ->
                val reaction = message.action ?: return@map null

                MessageUiState.Reaction(
                    type = reaction.type,
                    emoji = reaction.emoji,
                    from = message.from,
                    fromName = message.fromName,
                    fromMe = message.fromMe,
                )
            }
            .filterNotNull()
            .distinctBy { it.from }

        val messageText = when (type) {
            Type.Text -> text
            Type.Image -> "Sent an image"
            Type.Voice -> "Sent a voice message"
            else -> ""
        }

        return MessageUiState(
            id = id,
            text = messageText ?: "",
            isCurrentUserSender = fromMe,
            contact = contact,
            senderName = senderName ?: "",
            dateTime = timestamp.toString(),
            reactions = reactionsUiState,
            linkPreview = linkPreviewModel?.let {
                MessageUiState.LinkPreview(
                    body = it.body,
                    url = it.url,
                )
            },
            status = when (status) {
                Status.Pending -> MessageUiState.Status.Pending
                Status.Delivered -> MessageUiState.Status.Delivered
                Status.Read -> MessageUiState.Status.Read
                null -> null
            },
            type = MessageUiState.Type.Text
        )
    }

    companion object {
        val empty =
            WhapiMessageModel(
                id = "",
                fromMe = false,
                type = null,
                chatId = "",
                text = null,
                timestamp = Clock.System.now().epochSeconds.toInt(),
                from = "",
                fromName = null,
                action = null,
                linkPreviewModel = null,
                status = null,
                source = null,
            )
    }

    enum class Type {
        Text, Image, Voice, Action, LinkPreview
    }

    enum class Status {
        Pending, Delivered, Read
    }
}
